import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import metaService from '../../../../../service/MetaService';
import CollapseApuracao from './components/collapseApuracao/CollapseApuracao';

function AvaliacaoResultadoList() {
    const [metas, setMetas] = useState([]);
    const { id: idIndicador } = useParams();

    const loadData = useCallback(async () => {
        const response = await metaService.list({
            params: { search: `indicador.id==${idIndicador};apuracaoMeta!=null` },
        });
        setMetas(response);
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    return metas.map((meta, i) => <CollapseApuracao loadData={loadData} key={i} meta={meta} />);
}

export default AvaliacaoResultadoList;
